import React, { useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getAlertSettings, getSearchResults, cloneAlert, updateAlert } from '../../../../redux/actions'
import { NotificationToast } from '../../tools/Toast'
import { handleTextPrepper } from '../../../../utils'

// MUI
import { withStyles } from '@material-ui/styles'

import {
  Grid, Paper, Typography, Switch, Card, CardContent, Button,
  TextField, Checkbox, Divider, IconButton, Fab,
  FormControl, FormControlLabel, Chip, Select, MenuItem,
  Input, InputLabel, InputAdornment,
  List, ListItem, ListItemText, ListItemSecondaryAction,
  Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText
} from '@material-ui/core'

import Autocomplete from '@material-ui/lab/Autocomplete'
import Grow from '@material-ui/core/Grow'

// Icons
import {
  Delete as DeleteIcon, Search as SearchIcon
} from '@material-ui/icons'

import log from 'loglevel'

// Custom MUI
const AccessSwitch = withStyles({
  switchBase: {
    color: '#417FF0',
    '&$switchBase + $track': {
      backgroundColor: '#417FF0'
    },
    '&$checked': {
      color: '#A4D164'
    },
    '&$checked + $track': {
      backgroundColor: '#A4D164'
    }
  },
  checked: {},
  track: {}
})(Switch)

const CustomTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'black'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#A4D164'
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: '#A4D164'
      }
    }
  }
})(TextField)

const GreenCheckbox = withStyles({
  root: {
    color: '#595959',
    '&$checked': {
      color: '#A4D164'
    }
  },
  checked: {}
})((props) => <Checkbox color='default' {...props} />)

const StyledSwitch = withStyles({
  switchBase: {
    color: 'white',
    '&$checked': {
      color: '#A4D164'
    },
    '&$checked + $track': {
      backgroundColor: '#A4D164'
    }
  },
  checked: {},
  track: {}
})(Switch)

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
}

let indexNum = 0
let stationIndex = 0

const CloneAlerts = (props) => {
  const { cloneAlertID, classes, handleBacktrack, selectedKeys, editing } = props
  const dispatch = useDispatch()
  const selectedKey = selectedKeys[0]

  const Categories = useSelector(state => state.words.categories)
  const UsersList = useSelector(state => state.listings.users)
  const WorkstationsList = useSelector(state => state.listings.workstations)

  const [success, setSuccess] = useState(false)
  const [phraseInput, setPhraseInput] = useState('')

  const [formData, setFormData] = useState({
    emailNotificationName: '',
    emailNotificationDesc: '',
    type: 'S',
    minSeverity: 1,
    maxSeverity: 100,
    keyboard: 1,
    application: 1,
    privateAlert: 1,
    limitByTimeframe: 0,
    timeframe: 0,
    count: 0,
    resetCount: 0,
    groupByWorkstation: 0,
    groupByUser: 0,
    categories: [],
    usernames: [],
    workstations: []
  })

  const [formWords, setFormWords] = useState([])
  const [open, setOpen] = useState(false)
  const [deletedWords, setDeletedWords] = useState([])
  const [addedWords, setAddedWords] = useState([])

  const handleDataSet = useCallback((data) => {
    const editData = data[0]
    const usernames = editData.users.map(user => {
      const tempUsernames = UsersList.find(u => u.userID === user.userID)
      return tempUsernames
    })

    const workstations = editData.workstations.map(workstation => {
      const tempWorkstations = WorkstationsList.find(w => w.workstationID === workstation.workstationID)
      return tempWorkstations
    })

    const categories = editData.categories.map(category => {
      const tempCategories = Categories.find(c => c.categoryID === category.categoryID)
      return tempCategories
    })
    setFormData({
      ...formData,
      emailNotificationName: editData.emailNotificationName,
      emailNotificationDesc: editData.emailNotificationDesc,
      type: editData.type,
      minSeverity: editData.minSeverity,
      maxSeverity: editData.maxSeverity,
      keyboard: editData.keyboard ? 1 : 0,
      application: editData.application ? 1 : 0,
      privateAlert: editData.privateAlert ? 1 : 0,
      limitByTimeframe: editData.limitByTimeframe ? 1 : 0,
      timeframe: editData.timeframe,
      count: editData.count,
      resetCount: editData.resetCount,
      groupByWorkstation: editData.groupByWorkstation,
      groupByUser: editData.groupByUser,
      categories,
      usernames,
      workstations
    })

    setFormWords(editData.words)

    setSuccess(true)
  }, [UsersList, WorkstationsList, formData, Categories])

  useEffect(() => {
    if (editing === true && success === false) {
      dispatch(getAlertSettings(selectedKey, cloneAlertID, handleDataSet))
    } else if (editing === false && success === false) {
      dispatch(getAlertSettings(null, cloneAlertID, handleDataSet))
    }
  }, [dispatch, cloneAlertID, success, handleDataSet, editing, selectedKey])

  const togglePublicPrivate = () => {
    const newForm = { ...formData }
    newForm.privateAlert = !newForm.privateAlert
    setFormData(newForm)
  }

  const onChange = (prop) => e => {
    e.preventDefault()
    if (prop === 'phrase') {
      setPhraseInput(e.target.value)
    }
    setFormData({ ...formData, [prop]: e.target.value })
  }

  const [notInVaultError, setNotInVaultError] = useState(false)
  const [addDisable, setAddDisable] = useState(false)
  const fireNotFound = () => {
    setAddDisable(true)
    setNotInVaultError(true)
  }

  const fireFound = (data) => {
    setOpen(false)
    const { phrase, wordID } = data

    if (addedWords.findIndex(x => x.wordID === wordID) !== -1) {
      NotificationToast(true, 'This word has already been added.')
      setPhraseInput('')
    } else {
      NotificationToast(false, 'Word has successfully been added to this alert!')
      const wordsToAdd = [...addedWords]
      wordsToAdd.push({ phrase, wordID })
      setAddedWords(wordsToAdd)
      setPhraseInput('')
    }
  }

  const [alertTitle, setAlertTitle] = useState(false)

  const handleSearch = async () => {
    if (!phraseInput.match(/^[^.\s]/)) {
      NotificationToast(true, 'Phrase cannot contain spaces at the beginning of the line.')
    } else {
      const searchText = phraseInput.toUpperCase()
      const wordSearch = formWords.findIndex(x => x.phrase === searchText)
      if (wordSearch !== -1) {
        setOpen(true)
        setAlertTitle(true)
      } else {
        setOpen(true)
        setAlertTitle(false)
      }
    }
  }

  const handleDialogAction = async () => {
    const wordsToDelete = [...deletedWords]
    const searchText = phraseInput.toUpperCase()
    const index = formWords.findIndex(x => x.phrase === searchText)
    if (alertTitle) {
      wordsToDelete.push(formWords[index])
      setDeletedWords(wordsToDelete)
      setOpen(false)
      setPhraseInput('')
    } else if (!alertTitle) {
      const unitID = selectedKey
      dispatch(getSearchResults(unitID, searchText, fireFound, fireNotFound))
    }
  }

  const handleAddedWordDelete = (wordID, index) => {
    const newWordsToAdd = [...addedWords]
    newWordsToAdd.splice(index, 1)
    setAddedWords(newWordsToAdd)
  }

  const handleDeletedWordDelete = (wordID, index) => {
    const newWordsToDelete = [...deletedWords]
    newWordsToDelete.splice(index, 1)
    setDeletedWords(newWordsToDelete)
  }

  const handleClose = () => {
    setOpen(false)
    setAddDisable(false)
    setNotInVaultError(false)
    setPhraseInput('')
  }

  const setSource = (value) => {
    if (value === 'all') {
      const newForm = { ...formData }
      newForm.keyboard = 1
      newForm.application = 1
      setFormData(newForm)
    } else if (value === 'keyboard') {
      const newForm = { ...formData }
      newForm.keyboard = 1
      newForm.application = 0
      setFormData(newForm)
    } else if (value === 'application') {
      const newForm = { ...formData }
      newForm.keyboard = 0
      newForm.application = 1
      setFormData(newForm)
    }
  }

  const setCategories = (e) => {
    const categories = [...e.target.value]
    categories.forEach(category => {
      delete category.accountID
      delete category.categoryDesc
    })
    setFormData({ ...formData, categories: categories })
  }

  const handleAddUser = (e, user) => {
    const newUser = user[indexNum++]
    const users = [...formData.usernames]
    const index = users.indexOf(newUser)
    if (index === -1) {
      users.push(newUser)
    }
    setFormData({ ...formData, usernames: users })
  }
  const handleDeleteUser = (user) => {
    indexNum--
    const users = [...formData.usernames]
    const newuser = users.filter(entry => entry !== user)
    setFormData({ ...formData, usernames: newuser })
  }

  const handleAddStation = (e, station) => {
    const newStation = station[stationIndex++]
    const stations = [...formData.workstations]
    const index = stations.indexOf(newStation)
    if (index === -1) {
      stations.push(newStation)
    }
    setFormData({ ...formData, workstations: stations })
  }
  const handleDeleteStation = (station) => {
    stationIndex--
    const stations = [...formData.workstations]
    const newStation = stations.filter(entry => entry !== station)
    setFormData({ ...formData, workstations: newStation })
  }

  const handleTimeframeToggle = () => {
    if (formData.limitByTimeframe === 0) {
      setFormData({ ...formData, limitByTimeframe: 1 })
    } else {
      setFormData({ ...formData, limitByTimeframe: 0, timeframe: 0 })
    }
  }

  const toggleCountReset = () => {
    const newForm = { ...formData }
    newForm.resetCount = !newForm.resetCount
    setFormData(newForm)
  }

  const handleUsersToggle = () => {
    const newForm = { ...formData }
    newForm.groupByUser = !newForm.groupByUser
    setFormData(newForm)
  }

  const handleWorkstationsToggle = () => {
    const newForm = { ...formData }
    newForm.groupByWorkstation = !newForm.groupByWorkstation
    setFormData(newForm)
  }

  const fireSuccess = () => {
    if (editing) {
      NotificationToast(false, 'Alert Updated Successfully!')
    } else {
      NotificationToast(false, 'New Custom Alert Created Successfully!')
    }
    setFormWords([])
    handleBacktrack()
  }
  const fireFailure = () => {
    if (editing) {
      NotificationToast(true, 'Failed to Update Alert.')
    } else {
      NotificationToast(true, 'Failed to Create New Custom Alert.')
    }
  }

  const handleSubmit = () => {
    const unitID = selectedKey

    const users = [...formData.usernames]
    const newUsersArray = []
    users.forEach(user => {
      newUsersArray.push({ userID: user.userID })
    })

    const workstations = [...formData.workstations]
    const newWorkstationsArray = []
    workstations.forEach(workstation => {
      newWorkstationsArray.push({ workstationID: workstation.workstationID })
    })
    if (editing) {
      log.debug('hit editing')
      const alertData = {
        emailNotificationName: handleTextPrepper(formData.emailNotificationName),
        emailNotificationDesc: handleTextPrepper(formData.emailNotificationDesc),
        type: formData.type,
        keyboard: formData.keyboard ? 1 : 0,
        application: formData.application ? 1 : 0,
        limitByTimeframe: formData.limitByTimeframe ? 1 : 0,
        timeframe: formData.timeframe,
        words: [],
        count: formData.count,
        resetCount: formData.resetCount ? 1 : 0,
        groupByWorkstation: formData.groupByWorkstation ? 1 : 0,
        groupByUser: formData.groupByUser ? 1 : 0,
        privateAlert: formData.privateAlert ? 1 : 0,
        minSeverity: 1,
        maxSeverity: 100,
        categories: [...formData.categories],
        wordsToAdd: addedWords,
        wordsToDelete: deletedWords,
        usernames: [...newUsersArray],
        workstations: [...newWorkstationsArray],
        clonedAlert: 1
      }
      log.debug(alertData)
      dispatch(updateAlert(alertData, unitID, cloneAlertID, fireSuccess, fireFailure))
    } else {
      const alertData = {
        emailNotificationName: handleTextPrepper(formData.emailNotificationName),
        emailNotificationDesc: handleTextPrepper(formData.emailNotificationDesc),
        type: formData.type,
        keyboard: formData.keyboard ? 1 : 0,
        application: formData.application ? 1 : 0,
        limitByTimeframe: formData.limitByTimeframe ? 1 : 0,
        timeframe: formData.timeframe,
        count: formData.count,
        resetCount: formData.resetCount ? 1 : 0,
        groupByWorkstation: formData.groupByWorkstation ? 1 : 0,
        groupByUser: formData.groupByUser ? 1 : 0,
        privateAlert: formData.privateAlert ? 1 : 0,
        minSeverity: formData.minSeverity,
        maxSeverity: formData.maxSeverity,
        categories: [...formData.categories],
        wordsToAdd: addedWords,
        wordsToDelete: deletedWords,
        usernames: [...newUsersArray],
        workstations: [...newWorkstationsArray],
        clonedEmailNotificationID: cloneAlertID
      }
      dispatch(cloneAlert(alertData, unitID, fireSuccess, fireFailure))
    }
  }

  return (
    <Grid container direction='column' justify='center'>
      <Dialog
        open={open}
      >
        <DialogTitle classes={{ root: classes.blueText }}>{alertTitle ? 'Word Found' : 'Word Not Found'}</DialogTitle>
        <DialogContent>
          {alertTitle
            ? (
              <DialogContentText>This word or phrase is currently in the LearnSafe Preferred Alert. Would you like to remove it?</DialogContentText>
            )
            : (
              <DialogContentText>This word or phrase is not currently in the LearnSafe Preferred Alert. Would you like to add it?</DialogContentText>
            )}
          {notInVaultError &&
            <DialogContentText classes={{ root: classes.errorText }}>{`Error: "${phraseInput}" is not currently in your Word Vault and cannot be added.`}</DialogContentText>}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogAction} disabled={addDisable}>{alertTitle ? 'Delete Word' : 'Add Word'}</Button>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
      <Grid container item direction='column' justify='center' xs={12} style={{ height: 'auto' }}>
        <Grid container item className='mb-3'>
          <Button
            variant='contained'
            size='medium'
            className={classes.greenBtn}
            onClick={handleBacktrack}
          >
            Back
          </Button>
        </Grid>
        <Paper elevation={2} className={classes.editPaper}>
          <Grid
            container
            direction='column'
            justify='center'
            className='px-3 w-100 py-3 mx-auto my-auto'
            spacing={2}
          >
            <Grid container item>
              <Grid container item xs={12} alignContent='center' className='mb-3'>
                <Grid container direction='row'>
                  <Grid item container direction='column' xs={7}>
                    <Typography variant='h4' color='primary' className='font-weight-bold' classes={{ colorPrimary: classes.blueText }}>Custom Alert</Typography>
                    <Typography variant='subtitle2' style={{ textTransform: 'none' }} className='text-muted'>This form will allow you to customize a LearnSafe Preferred Alert to your organization.</Typography>
                  </Grid>

                  <Grid item xs={5}>
                    <Grid item container direction='row' justify='flex-end'>
                      <Typography component='div'>
                        <Grid component='label' container alignItems='center' spacing={1}>
                          <Grid item>
                            <Typography style={{ fontSize: '.8rem', fontWeight: 'bold' }} classes={{ colorPrimary: classes.blueText }} color='primary'>Public</Typography>
                          </Grid>
                          <Grid item>
                            <AccessSwitch
                              checked={!!formData.privateAlert}
                              onClick={togglePublicPrivate}
                            />
                          </Grid>
                          <Grid item>
                            <Typography style={{ fontSize: '.8rem', fontWeight: 'bold' }} classes={{ colorPrimary: classes.blueText }} color='primary'>Private</Typography>
                          </Grid>
                        </Grid>
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              {/* Alert Name */}
              <Grid container>
                <Grid item>
                  <Typography
                    variant='h6'
                    color='primary'
                    classes={{ colorPrimary: classes.blueText }}
                    className='font-weight-bold'
                    gutterBottom
                  >
                    Alert Name:
                  </Typography>
                </Grid>

                <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto mb-2 px-3'>
                  <Grid item xs={12}>
                    <Card className='mb-2'>
                      <CardContent style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                        <Grid item container direction='row' className='mb-0'>
                          <FormControl className='w-100'>
                            <CustomTextField
                              label='Alert Name'
                              required
                              name='emailNotificationName'
                              variant='outlined'
                              value={formData ? formData.emailNotificationName : ''}
                              fullWidth
                              error={formData.emailNotificationName.length === 0}
                              onChange={onChange('emailNotificationName')}
                            />
                          </FormControl>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>

              {/* Alert Description */}
              <Grid container>
                <Grid item>
                  <Typography
                    variant='h6'
                    color='primary'
                    classes={{ colorPrimary: classes.blueText }}
                    className='font-weight-bold'
                    gutterBottom
                  >
                    Alert Description:
                  </Typography>
                </Grid>

                <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto mb-2 px-3'>
                  <Grid item xs={12}>
                    <Card className='mb-2'>
                      <CardContent style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                        <Grid item container direction='row' className='mb-0'>
                          <FormControl className='w-100'>
                            <CustomTextField
                              label='Alert Description'
                              required
                              name='emailNotificationDesc'
                              multiline
                              rows={2}
                              variant='outlined'
                              value={formData ? formData.emailNotificationDesc : ''}
                              fullWidth
                              error={formData.emailNotificationDesc.length === 0}
                              onChange={onChange('emailNotificationDesc')}
                            />
                          </FormControl>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>

              </Grid>
              {/* Words */}
              <Grid container>
                <Grid item>
                  <Typography
                    variant='h6'
                    color='primary'
                    classes={{ colorPrimary: classes.blueText }}
                    className='font-weight-bold'
                    gutterBottom
                  >
                    Words:
                  </Typography>
                </Grid>
                <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto mb-2 px-3'>
                  <Grid item xs={12}>
                    <Card className='mb-2'>
                      <CardContent>
                        <Grid item xs={12}>
                          <Grid container>
                            <Grid item>
                              <Typography
                                variant='h6'
                                color='primary'
                                classes={{ colorPrimary: classes.blueText }}
                                className='font-weight-bold mt-2'
                              >
                                Search
                              </Typography>
                              <Typography variant='subtitle2' className='text-muted' style={{ textTransform: 'none' }}>
                                Add or remove words for this alert.
                              </Typography>
                            </Grid>

                            <Grid
                              container
                              direction='row'
                              spacing={2}
                              className='w-100 mx-auto mb-2 px-2'
                              name='sourceGroup'
                              id='sourceGroup'
                              style={{ marginBottom: '10px' }}
                            >
                              <Grid item xs={12} className='w-100 mx-auto'>
                                <TextField
                                  placeholder='Search Phrase'
                                  variant='filled'
                                  color='primary'
                                  onChange={onChange('phrase')}
                                  value={phraseInput}
                                  onBlur={handleSearch}
                                  classes={{
                                    root: classes.inputRoot
                                  }}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position='start' className='mb-3'>
                                        <Fab
                                          className={classes.searchBtn}
                                          size='small'
                                          onClick={handleSearch}
                                        >
                                          <SearchIcon />
                                        </Fab>
                                      </InputAdornment>
                                    )
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item container direction='row' style={deletedWords.length === 0 ? { height: '90px' } : { height: '200px', overflow: 'scroll' }}>
                            <Grid item xs={12}>
                              <Typography
                                variant='h6'
                                color='primary'
                                classes={{ colorPrimary: classes.blueText }}
                                className='font-weight-bold mt-2'
                              >
                                Words to be Removed from Cloned Alert:
                              </Typography>
                              <List dense className={classes.wordList}>
                                {deletedWords.length === 0
                                  ? (
                                    <ListItem>
                                      <ListItemText primary='No words set to be removed.' />
                                    </ListItem>
                                  )
                                  : (
                                    deletedWords.map((word, index) => {
                                      return (
                                        <React.Fragment key={word.wordID}>
                                          <ListItem>
                                            <ListItemText
                                              style={{ fontWeight: 'bold' }}
                                              primary={word.phrase}
                                            />
                                            <ListItemSecondaryAction>
                                              <IconButton
                                                edge='end'
                                                aria-label='delete'
                                                onClick={(e) => { e.preventDefault(); handleDeletedWordDelete(word.wordID, index) }}
                                              >
                                                <DeleteIcon />
                                              </IconButton>
                                            </ListItemSecondaryAction>
                                          </ListItem>
                                          <Divider variant='middle' />
                                        </React.Fragment>
                                      )
                                    })
                                  )}
                              </List>
                            </Grid>
                          </Grid>
                          <Grid item container direction='row' style={addedWords.length === 0 ? { height: '90px' } : { height: '200px', overflow: 'scroll' }}>
                            <Grid item xs={12}>
                              <Typography
                                variant='h6'
                                color='primary'
                                classes={{ colorPrimary: classes.greenText }}
                                className='font-weight-bold mt-2'
                              >
                                Words to be Added to the Cloned Alert:
                              </Typography>
                              <List dense className={classes.wordList}>
                                {addedWords.length === 0
                                  ? (
                                    <ListItem>
                                      <ListItemText primary='No words set to be added' />
                                    </ListItem>
                                  )
                                  : (
                                    addedWords.map((word, index) => {
                                      return (
                                        <React.Fragment key={word.wordID}>
                                          <ListItem>
                                            <ListItemText
                                              style={{ fontWeight: 'bold' }}
                                              primary={word.phrase}
                                            />
                                            <ListItemSecondaryAction>
                                              <IconButton
                                                edge='end'
                                                aria-label='delete'
                                                onClick={(e) => { e.preventDefault(); handleAddedWordDelete(word.wordID, index) }}
                                              >
                                                <DeleteIcon />
                                              </IconButton>
                                            </ListItemSecondaryAction>
                                          </ListItem>
                                          <Divider variant='middle' />
                                        </React.Fragment>
                                      )
                                    })
                                  )}
                              </List>
                            </Grid>
                          </Grid>
                          {/* Sources */}
                          <Grid container>
                            <Grid item>
                              <Typography
                                variant='h6'
                                color='primary'
                                classes={{ colorPrimary: classes.blueText }}
                                className='font-weight-bold'
                                gutterBottom
                              >
                                Sources
                              </Typography>
                            </Grid>

                            <Grid
                              container
                              direction='row'
                              spacing={2}
                              className='w-100 mx-auto mb-2 px-2'
                              name='sourceGroup'
                              id='sourceGroup'
                              style={{ marginBottom: '10px' }}
                            >
                              <Grid item>
                                <Button
                                  variant='contained'
                                  id='keyboard'
                                  color='primary'
                                  onClick={() => setSource('keyboard')}
                                  classes={{ containedPrimary: formData.keyboard === 1 && formData.application === 0 ? classes.blueBtn : classes.greenBtn }}
                                  style={{ marginRight: '10px' }}
                                >
                                  Keyboard
                                </Button>
                                <Button
                                  variant='contained'
                                  id='application'
                                  color='primary'
                                  classes={{ containedPrimary: formData.keyboard === 0 && formData.application === 1 ? classes.blueBtn : classes.greenBtn }}
                                  style={{ marginRight: '10px' }}
                                  onClick={() => setSource('application')}
                                >
                                  Application
                                </Button>
                                <Button
                                  variant='contained'
                                  id='all'
                                  color='primary'
                                  onClick={() => setSource('all')}
                                  classes={{ containedPrimary: formData.keyboard === 1 && formData.application === 1 ? classes.blueBtn : classes.greenBtn }}
                                >
                                  All
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
              {/* Categories */}
              <Grid container>
                <Grid item>
                  <Typography
                    variant='h6'
                    color='primary'
                    classes={{ colorPrimary: classes.blueText }}
                    className='font-weight-bold'
                    gutterBottom
                  >
                    Categories:
                  </Typography>
                </Grid>

                <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto mb-2 px-3'>
                  <Grid item xs={12}>
                    <Card className='mb-2'>
                      <CardContent>
                        <Grid item container direction='row' className='mb-0'>
                          <Grid item xs={12}>
                            <Typography variant='subtitle2' className='text-muted' style={{ textTransform: 'none', marginTop: '.7rem' }}>
                              Select specific categories to set for this alert.
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid item container direction='row' className='mb-0 mt-2'>
                          <Grid item xs={12}>
                            <FormControl className='w-100'>
                              <InputLabel id='category-multi-select'>Select Categories</InputLabel>
                              <Select
                                labelId='category-multi-select'
                                label='Select Categories'
                                id='categories'
                                className='mb-2'
                                multiple
                                value={formData.categories}
                                onChange={setCategories}
                                input={<Input id='Categories' classes={{ underline: classes.underline }} />}
                                renderValue={(selected) => (
                                  <div className={classes.chips}>
                                    {selected.map((value, index) => (
                                      <Chip
                                        key={index}
                                        label={value.categoryName}
                                        className={classes.chip}
                                        onDelete={() => log.debug(index)}
                                      />
                                    ))}
                                  </div>
                                )}
                                MenuProps={MenuProps}
                              >
                                {Categories.map((category, index) => (
                                  <MenuItem key={category.categoryID} value={category}>
                                    {category.categoryName}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>

                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>

              {/* Users */}
              <Grid container>
                <Grid item>
                  <Typography
                    variant='h6'
                    className='font-weight-bold'
                    color='primary'
                    classes={{ colorPrimary: classes.blueText }}
                    gutterBottom
                  >
                    Users:
                  </Typography>
                </Grid>

                <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto mb-2 px-3'>
                  <Grid item xs={12}>
                    <Card className='mb-2'>
                      <CardContent>
                        <Grid item container direction='row' className='mb-0'>
                          <Grid item xs={12}>
                            <Typography variant='subtitle2' className='text-muted' style={{ textTransform: 'none', marginTop: '.7rem' }}>
                              Start typing a specific users name to find and add them for this alert.
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid item container direction='row' className='mb-0 mt-2'>
                          <Grid item xs={12}>
                            <Autocomplete
                              multiple
                              filterSelectedOptions
                              id='users-select'
                              options={UsersList}
                              value={formData.usernames}
                              getOptionLabel={(option) => option.username}
                              onChange={(e, newValue) => handleAddUser(e, newValue)}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant='standard'
                                  label='Select Users'
                                  className='mb-2'
                                />
                              )}
                              renderTags={(value, getTagProps) =>
                                formData.usernames.map((user, index) => (
                                  <Chip
                                    {...getTagProps({ index })}
                                    variant='outlined'
                                    key={`user-${user.username}`}
                                    label={user.username}
                                    onDelete={() => handleDeleteUser(user)}
                                  />
                                ))}
                            />
                          </Grid>
                        </Grid>

                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>

              {/* Workstations */}
              <Grid container>
                <Grid item>
                  <Typography
                    variant='h6'
                    className='font-weight-bold'
                    color='primary'
                    gutterBottom
                    classes={{ colorPrimary: classes.blueText }}
                  >
                    Workstations:
                  </Typography>
                </Grid>

                <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto mb-2 px-3'>
                  <Grid item xs={12}>
                    <Card className='mb-2'>
                      <CardContent>
                        <Grid item container direction='row' className='mb-0'>
                          <Grid item xs={12}>
                            <Typography variant='subtitle2' className='text-muted' style={{ textTransform: 'none', marginTop: '.7rem' }}>
                              Start typing a specific workstation name to find and add it for this alert.
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid item container direction='row' className='mb-0 mt-2'>
                          <Grid item xs={12}>
                            <Autocomplete
                              multiple
                              filterSelectedOptions
                              id='workstations-select'
                              options={WorkstationsList}
                              value={formData.workstations}
                              getOptionLabel={(option) => option.hostname}
                              onChange={(e, newValue) => handleAddStation(e, newValue)}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant='standard'
                                  label='Select Workstations'
                                  className='mb-2'
                                />
                              )}
                              renderTags={(value, getTagProps) =>
                                formData.workstations.map((station, index) => (
                                  <Chip
                                    {...getTagProps({ index })}
                                    variant='outlined'
                                    key={`station-${station.workstationID}`}
                                    label={station.hostname}
                                    onDelete={() => handleDeleteStation(station)}
                                  />
                                ))}
                            />
                          </Grid>
                        </Grid>

                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>

              {/* Timeframe */}
              <Grid container>
                <Grid item>
                  <Typography
                    variant='h6'
                    color='primary'
                    classes={{ colorPrimary: classes.blueText }}
                    className='font-weight-bold'
                    gutterBottom
                  >
                    Timeframe:
                  </Typography>
                </Grid>

                <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto px-3'>
                  <Grid item xs={12}>
                    <Card className='mb-2'>
                      <CardContent>
                        <Grid item container direction='row' className='mb-0'>
                          <Grid item xs={10}>
                            <Typography variant='subtitle2' className='text-muted' style={{ textTransform: 'none', marginTop: '.7rem' }}>
                              If enabled, a timeframe can be set for this alert.
                            </Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <GreenCheckbox
                              className='ml-3'
                              value='severity'
                              onChange={handleTimeframeToggle}
                              checked={!!formData.limitByTimeframe}
                            />
                          </Grid>
                        </Grid>
                        <Grow in={formData.limitByTimeframe || formData.limitByTimeframe === 1} timeout={500} unmountOnExit>
                          <Grid item xs={12}>
                            <Grid item container direction='row' className='mb-0 mt-2'>
                              <FormControl fullWidth className='mb-2'>
                                <CustomTextField
                                  label='Number Of Minutes'
                                  type='number'
                                  name='timeframe'
                                  variant='outlined'
                                  value={formData.timeframe ? formData.timeframe : ''}
                                  onChange={onChange('timeframe')}
                                  fullWidth
                                />
                              </FormControl>
                            </Grid>

                            <Grid item container direction='row' className='mb-0 mt-3'>
                              <Grid item xs={6}>
                                <FormControl className='w-100'>
                                  <CustomTextField
                                    label='Reset Count Number'
                                    type='number'
                                    InputProps={{
                                      inputProps: {
                                        max: 100, min: 0
                                      }
                                    }}
                                    name='count'
                                    variant='outlined'
                                    value={formData.count ? formData.count : ''}
                                    onChange={onChange('count')}
                                    fullWidth
                                  />
                                </FormControl>
                              </Grid>

                              <Grid item xs={6}>
                                <Grid item container justify='center'>
                                  <Typography
                                    variant='body1'
                                    component='label'
                                    color='primary'
                                    className='font-weight-bold'
                                    classes={{ colorPrimary: classes.blueText }}
                                  >
                                    Clear Counter
                                  </Typography>
                                </Grid>

                                <Grid item container justify='center'>
                                  <FormControlLabel
                                    label={formData.resetCount ? 'Enabled' : 'Disabled'}
                                    control={
                                      <StyledSwitch
                                        checked={!!formData.resetCount}
                                        onClick={toggleCountReset}
                                      />
                                    }
                                    labelPlacement='end'
                                  />
                                </Grid>
                              </Grid>

                              <Grid item container direction='row' className='mb-0 mt-3'>
                                <Grid item xs={5}>
                                  <Grid item container justify='center'>
                                    <Typography
                                      variant='body1'
                                      component='label'
                                      color='primary'
                                      className='font-weight-bold'
                                      classes={{ colorPrimary: classes.blueText }}
                                      style={{ fontSize: '.9rem' }}
                                    >
                                      Group By Users
                                    </Typography>
                                  </Grid>

                                  <Grid item container justify='center'>
                                    <FormControlLabel
                                      label={formData.groupByUser ? 'Enabled' : 'Disabled'}
                                      control={
                                        <StyledSwitch
                                          checked={!!formData.groupByUser}
                                          onClick={handleUsersToggle}
                                        />
                                      }
                                      labelPlacement='end'
                                    />
                                  </Grid>
                                </Grid>

                                <Grid item xs={7}>
                                  <Grid item container justify='center'>
                                    <Typography
                                      variant='body1'
                                      component='label'
                                      color='primary'
                                      className='font-weight-bold'
                                      classes={{ colorPrimary: classes.blueText }}
                                      style={{ fontSize: '.9rem' }}
                                    >
                                      Group By Workstations
                                    </Typography>
                                  </Grid>

                                  <Grid item container justify='center'>
                                    <FormControlLabel
                                      label={formData.groupByWorkstation ? 'Enabled' : 'Disabled'}
                                      control={
                                        <StyledSwitch
                                          checked={!!formData.groupByWorkstation}
                                          onClick={handleWorkstationsToggle}
                                        />
                                      }
                                      labelPlacement='end'
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>

                            </Grid>
                          </Grid>
                        </Grow>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>

            </Grid>
          </Grid>
        </Paper>
        <Button
          variant='contained'
          size='medium'
          className={`mt-2 ${classes.blueBtn}`}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  )
}

export default CloneAlerts
